import { create } from "zustand";
export const useShippingsStore = create((set) => ({
  shippings: null,
  shipping: null,
  glsPackagesList: null,
  setShippings: (shippings) => set({ shippings }),
  setShipping: (shipping) => set({ shipping }),
  setGlsPackagesList: (glsPackagesList) => set({ glsPackagesList }),
}));
